import { MouseEvent, useEffect, useState } from 'react';
import { MenuToggle } from '../MenuToggle';
import { Link, useLocation } from 'react-router';

interface Props {
  ctaLabel: string;
  ctaTo: string;
}

export function HomeHeader({ ctaLabel, ctaTo }: Props) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Sluit het menu zodra een anchor wordt gevolgd of het pad verandert.
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  function handleLogoClick(e: MouseEvent<HTMLAnchorElement>) {
    if (location.pathname !== '/') {
      return;
    }
    e.preventDefault();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  }

  function handleAnchorClick() {
    setMenuOpen(false);
  }

  return (
    <header className={`home-header${scrolled ? ' scrolled' : ''}${menuOpen ? ' menu-open' : ''}`}>
      <div className="home-header-inner">
        <Link to="/" onClick={handleLogoClick}>
          <img
            src="/logo-horizontal-color.svg"
            alt="Beleidssignaal"
            className="home-header-logo"
            width="360"
            height="64"
          />
        </Link>
        <nav className="home-nav" id="home-nav">
          <a href="#wat" onClick={handleAnchorClick}>
            Wat is het
          </a>
          <a href="#voor-wie" onClick={handleAnchorClick}>
            Voor wie
          </a>
          <a href="#hoe" onClick={handleAnchorClick}>
            Hoe het werkt
          </a>
          <a href="#faq" onClick={handleAnchorClick}>
            Veelgestelde vragen
          </a>
          <a href="#contact" onClick={handleAnchorClick}>
            Contact
          </a>
          <Link to={ctaTo} className="home-nav-cta" onClick={handleAnchorClick}>
            {ctaLabel}
          </Link>
        </nav>
        <Link to={ctaTo} className="home-header-cta">
          {ctaLabel}
        </Link>
        <MenuToggle
          open={menuOpen}
          onToggle={() => setMenuOpen((isOpen) => !isOpen)}
          controls="home-nav"
          className="home-menu-toggle"
        />
      </div>
    </header>
  );
}
